import { SandboxTemplate } from "../../model/sandboxes/SDKSandboxTemplate";
export class AreaSandboxes {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    async getSandboxTemplateList({ workspaceId, designSystemId, }) {
        const response = await this.dataCore.getSandboxTemplates({
            workspaceId,
            designSystemId,
        });
        return response.templates.map((t) => new SandboxTemplate(t));
    }
    async sandboxKeepAlive(workspaceId, projectId, featureId, sandboxId) {
        return this.dataCore.sandboxKeepAlive(workspaceId, projectId, featureId, sandboxId);
    }
    async provisionSandbox(workspaceId, projectId, featureId, parentMessageId) {
        return this.dataCore.provisionSandbox(workspaceId, projectId, featureId, parentMessageId);
    }
}
